import React, { useEffect } from 'react';
import { Prompt } from 'react-router-dom';

type NavigationBlockerProps = {
  navigationBlocked: boolean;
  message?: string;
};
const NavigationBlocker = ({
  navigationBlocked,
  message = null,
}: NavigationBlockerProps) => {
  useEffect(() => {
    if (navigationBlocked) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = null;
    }

    return () => (window.onbeforeunload = null);
  }, [navigationBlocked]);

  if (!navigationBlocked) {
    return null;
  }

  return (
    <div>
      <Prompt
        when={navigationBlocked}
        message={
          message
            ? message
            : 'You have unsaved changes. Are you sure you want to leave this page?'
        }
      />
    </div>
  );
};

export default NavigationBlocker;
